var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "suspen_box",
      class: _vm.fadeInRight ? "ke_animation_fadeInRight" : ""
    },
    [
      _c("i", {
        staticClass: "el-icon-caret-left suspen_corner",
        on: {
          click: function($event) {
            _vm.fadeInRight = true
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "icon_box" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "icon_item", on: { click: _vm.chatOpen } }, [
          _c("img", {
            attrs: { src: require("../assets/images/suspen3.png"), alt: "" }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "icon_item",
            attrs: { id: "backtop" },
            on: {
              click: function($event) {
                return _vm.getScrollTop()
              }
            }
          },
          [
            _c("img", {
              attrs: { src: require("../assets/images/suspen4.png"), alt: "" }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm.chatShow
        ? _c("div", { staticClass: "chat_box" }, [
            _c("div", { staticClass: "chat_header" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("div", {
                staticClass: "el-icon-close close_btn",
                on: {
                  click: function($event) {
                    _vm.chatShow = false
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "chat_main", attrs: { id: "chatBox" } },
              _vm._l(_vm.chatList, function(item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "item_box",
                    class: {
                      left: item.type == "a" || item.type == "r",
                      right: item.type == "q"
                    }
                  },
                  [
                    _c("div", { staticClass: "chat_item" }, [
                      _vm._v(_vm._s(item.text))
                    ]),
                    _vm._v(" "),
                    item.type == "r"
                      ? _c(
                          "div",
                          { staticClass: "recommend_list" },
                          _vm._l(item.recommendList, function(ele, i) {
                            return _c(
                              "div",
                              {
                                key: i,
                                staticClass: "recommend_item",
                                on: {
                                  click: function($event) {
                                    return _vm.chooseQuestion(ele.Title)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(ele.Title))]
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input_box" },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入" },
                  nativeOn: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.sendChat()
                    }
                  },
                  model: {
                    value: _vm.chatInputValue,
                    callback: function($$v) {
                      _vm.chatInputValue = $$v
                    },
                    expression: "chatInputValue"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "send_btn", on: { click: _vm.sendChat } },
                  [_vm._v("发送")]
                )
              ],
              1
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "icon_item webchat_item media_small_hide" },
      [
        _c("img", {
          attrs: { src: require("../assets/images/suspen2.png"), alt: "" }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "wx_box" }, [
          _c("img", {
            attrs: { src: require("../assets/images/wx-code.png"), alt: "" }
          }),
          _c("span")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "server" }, [
      _c("div", { staticClass: "server_avatar" }, [
        _c("img", {
          attrs: { src: require("../assets/images/logo.png"), alt: "" }
        })
      ]),
      _vm._v("\n        开尔客服\n      ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76e1fb38", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76e1fb38","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/suspen.vue
// module id = null
// module chunks = 